import React, { useMemo } from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { secondsUntil } from '../../../utils/seconds-until';
import {
  makeString,
  makeStringWithoutLetters,
  calculateTimeRemaining,
} from '../../../utils/timer';
import { firstLetterToUppter } from '../../../utils/first-letter-to-upper';
import ArrowDown from '../../../assets/logos/arrow-down.svg';
import ArrowUp from '../../../assets/logos/arrow-up.svg';
import moment from 'moment-timezone';
import { useTradeHistory } from '../../../hooks/useTrade'
import { X } from 'react-feather';
import { cn } from '@utils/utils';

const TradeResultContent = ({ trade, closeModal }) => {

  return (
    <div className="flex flex-col gap-4 items-center w-[90%]">
      {trade.status === 'profit' ? (
        <span className="text-5xl font-semibold text-green-600">
          {trade.profit}$
        </span>
      ) : (
        <span className="text-5xl font-semibold text-red-600">
          {trade.loss}$
        </span>
      )}
      <div className="flex flex-col gap-10 w-full text-xl">
        <div className="flex justify-between w-full">
          <span>Date & Time </span>
          <span>
            {moment.utc(trade?.startDate).local().format('YYYY-MM-DD HH:mm:ss')}
          </span>
        </div>
        <div className="flex justify-between w-full">
          <span>Coin </span>
          <span>{firstLetterToUppter(trade.coinId)}</span>
        </div>
        <div className="flex justify-between w-full">
          <span>Type </span>
          <span
            className={
              trade.type === 'sell' ? 'text-red-700' : 'text-green-700'
            }
          >
            {firstLetterToUppter(trade.type)}
          </span>
        </div>
        <div className="flex justify-between w-full">
          <span>Amount </span>
          <span>{trade.amount}$</span>
        </div>
        <div className="flex justify-between w-full">
          <span>Result </span>
          <span>
            {trade.status === 'loss' ? (
              <span className="text-red-700">Loss ({trade.loss}$)</span>
            ) : (
              <span className="text-green-700">Profit (+{trade.profit}$)</span>
            )}
          </span>
        </div>
      </div>

      <button onClick={() => closeModal()} className={`mt-10 w-full px-8 py-6 border-none rounded-full text-base font-medium bg-[#77ED91] text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out hover:bg-[white] hover:scale-110 text-center`}>
        OK
      </button>
    </div>
  );
};

const TradeModal = ({ coins }) => {
  const { getTradeInModal, closeModal } = useTradeHistory();

  const trade = getTradeInModal();
  const currentCoin = coins.find((image) => image.id === trade.coinId);
  const endSeconds = useMemo(() => secondsUntil(trade.endDate), []);
  const [timeRemain, setTimeRemain] = React.useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  return (
    <section
      className="wallet_modal_wrapper flex !justify-center !items-center"
      onClick={(e) => {
        e.stopPropagation();
        closeModal();
      }}
    >
      <div
        className="wallet_modal !justify-normal !w-full !max-w-[90%] lg:!max-w-[600px]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="wallet_modal_header">
          <h1 className="wallet_modal_title">
            {!trade.ended ? 'Active trade' : 'Trade closed'}
          </h1>
          <X className="wallet_modal_close" onClick={() => closeModal()} />
        </div>
        <div className="flex justify-center flex-col items-center flex-1">
          {trade.ended ? (
            <TradeResultContent trade={trade} closeModal={closeModal} />
          ) : (
            <>
              <div className="flex gap-4 items-center text-4xl">
                <img className="w-[48px]" src={currentCoin.icon} alt="" />
                <span className="font-semibold">
                  {firstLetterToUppter(trade.coinId)}
                </span>
              </div>
              <div className="flex gap-4 items-center my-8">
                <span className="text-2xl mr-4 font-semibold">
                  ${trade.amount}
                </span>
                <div
                  className={cn(
                    'flex gap-2 items-center text-white px-4 py-2 rounded-full',
                    { 'bg-red-700': trade.type === 'sell' },
                    { 'bg-green-700': trade.type === 'buy' },
                  )}
                >
                  <img
                    src={trade.type === 'buy' ? ArrowUp : ArrowDown}
                    alt=""
                  />
                  <span>{firstLetterToUppter(trade.type)}</span>
                </div>
              </div>
              <CountdownCircleTimer
                isPlaying
                duration={endSeconds}
                colors={['#00C853']}
                strokeWidth={18}
                onUpdate={(remainingTime) => {
                  setTimeRemain(calculateTimeRemaining(trade.endDate));
                }}
              >
                {({ remainingTime }) => {
                  return (
                    <span className="text-4xl">
                      {makeStringWithoutLetters(timeRemain)}
                    </span>
                  );
                }}
              </CountdownCircleTimer>
              <p className="mt-8 text-gray-400">
                Trade will close in {makeString(timeRemain, false)}
              </p>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default TradeModal